module.exports = __webpack_public_path__ + "static/icons/person-3-4.1df341e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nps/person-3-4.svg
// module id = 59ae
// module chunks = 1